import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import { apisConfig } from './apis.config';

export const apisModule = createFrontendModule({
  pluginId: 'app',
  extensions: apisConfig.map((factory, i) =>
    ApiBlueprint.make({
      name: `custom-api-${i}`,
      params: defineParams => defineParams(factory),
    }),
  ),
});
